<i class="nimbus-info-banner-icon" [nimbusIcon]="iconToRender"></i>
<span class="nimbus-info-banner-text"><ng-content></ng-content></span>
